import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 23vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.WHITE};
  padding: 1rem;
  border-radius: 1rem;
  cursor: pointer;
`;

export const UploadContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  box-sizing: border-box;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='limegreen' stroke-width='4' stroke-dasharray='15' stroke-dashoffset='30' stroke-linecap='round'/%3e%3c/svg%3e");
  border-radius: 0.75rem;
`;

export const ImageContainer = styled.div`
  height: 60%;
  width: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const imageStyle = {
  height: '14vh',
  width: '14vw',
};

export default {
  Container,
  UploadContainer,
  ImageContainer,
  imageStyle,
};
